/** Labels for raw wallet claim keys (snake_case) and Identity camelCase fields. */
export const CLAIM_LABELS = {
  given_name: 'Given name',
  givenName: 'Given name',
  family_name: 'Family name',
  familyName: 'Family name',
  birth_date: 'Date of birth',
  birthDate: 'Date of birth',
  birth_place: 'Place of birth',
  birthPlace: 'Place of birth',
  nationality: 'Nationality',
  issuing_country: 'Issuing country',
  issuingCountry: 'Issuing country',
  issuing_authority: 'Issuing authority',
  issuingAuthority: 'Issuing authority',
  document_number: 'Document no.',
  documentNumber: 'Document no.',
  expiry_date: 'Expiry',
  documentExpiry: 'Expiry',
  issue_date: 'Issue date',
  issueDate: 'Issue date',
  address: 'Address',
  city: 'City',
  postal_code: 'Postal code',
  postalCode: 'Postal code',
  country: 'Country',
  state: 'State / region',
  age_over_18: 'Age 18+',
  ageOver18: 'Age 18+',
  age_over_21: 'Age 21+',
  ageOver21: 'Age 21+',
  resident_address: 'Residence address',
};

export function formatClaimValue(value) {
  if (value === null || value === undefined) return null;
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'object') return JSON.stringify(value, null, 2);
  const s = String(value);
  return s.length > 0 ? s : null;
}

/** Prefer raw claims map; fall back to normalized identity object. */
export function collectClaimEntries(claims, identity) {
  const entries = [];
  const seen = new Set();

  const add = (key, value) => {
    const formatted = formatClaimValue(value);
    if (formatted == null) return;
    if (seen.has(key)) return;
    seen.add(key);
    entries.push({ key, label: CLAIM_LABELS[key] || key.replace(/_/g, ' '), value: formatted });
  };

  if (claims && typeof claims === 'object') {
    Object.entries(claims).forEach(([k, v]) => add(k, v));
  }
  if (identity && typeof identity === 'object') {
    Object.entries(identity).forEach(([k, v]) => add(k, v));
  }

  return entries;
}
